"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBDownloadPopup", {
  enumerable: true,
  get: function get() {
    return _SVBDownloadPopup.default;
  }
});
var _SVBDownloadPopup = _interopRequireDefault(require("./src/SVBDownloadPopup"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }